import React from 'react';

export interface DashboardSectionHeaderProps {
  title: string;
  right?: React.ReactNode;
}

export function DashboardSectionHeader({ title, right }: DashboardSectionHeaderProps) {
  return (
    <div className="d-flex align-items-center justify-content-between mb-2">
      <div className="d-flex align-items-center gap-2">
        <span
          className="rounded-circle flex-shrink-0 bg-primary"
          style={{ display: 'inline-block', width: 8, height: 8 }}
        />
        <span
          className="fw-bold text-uppercase text-secondary"
          style={{ fontSize: '12px', letterSpacing: '1px' }}
        >
          {title}
        </span>
      </div>
      {right && <span className="small">{right}</span>}
    </div>
  );
}
